import { Box, useTheme } from "@mui/material";
import React, { useState } from "react";
import { tokens } from "../../../../theme";
import Header from "../../../../components/Header";
import { ToastContainer, toast } from "react-toastify";
import { ThreeDMarquee } from "../../../../components/ui/3d-marquee";

const Partnersdashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [selectedPartner, setSelectedPartner] = useState(null);
  const [selectedCredit, setSelectedCredit] = useState({});

  const partners = [
    { id: "GYAANi", name: "GYAANi", color: "green" },
    { id: "aism", name: "ai-SM", color: "black" },
    { id: "inspire", name: "iNSPIRE", color: "red" },
    { id: "auto-bot", name: "auto-BOT", color: "blue" },
    { id: "insight", name: "iNSIGHT", color: "maroon" },
  ];

  const creditOptions = [500, 1000, 2000, "unlimited"];

  const handlePartnerSelect = (partnerId) => {
    // If selecting same partner, toggle it off
    if (selectedPartner === partnerId) {
      setSelectedPartner(null);
      setSelectedCredit(null);
    } else {
      setSelectedPartner(partnerId);
      setSelectedCredit(null); // Reset credit when changing partner
    }
  };

  const handleCreditSelect = (credit) => {
    setSelectedCredit(credit);
  };



  const GYANNiimages = [
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-33-43.png?updatedAt=1746615841892",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-05.png?updatedAt=1746615806436",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-39.png?updatedAt=1746615806411",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-19.png?updatedAt=1746615806634",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-53.png?updatedAt=1746615806409",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-33-43.png?updatedAt=1746615841892",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-47.png?updatedAt=1746615806661",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-26.png?updatedAt=1746615806267",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-33-43.png?updatedAt=1746615841892",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-47.png?updatedAt=1746615806661",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-19.png?updatedAt=1746615806634",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-53.png?updatedAt=1746615806409",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-33-43.png?updatedAt=1746615841892",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-19.png?updatedAt=1746615806634",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-53.png?updatedAt=1746615806409",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-47.png?updatedAt=1746615806661",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-39.png?updatedAt=1746615806411",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-05.png?updatedAt=1746615806436",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-53.png?updatedAt=1746615806409",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-26.png?updatedAt=1746615806267",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-47.png?updatedAt=1746615806661",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-33-43.png?updatedAt=1746615841892",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-05.png?updatedAt=1746615806436 ",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-26.png?updatedAt=1746615806267",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-33-43.png?updatedAt=1746615841892",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-39.png?updatedAt=1746615806411",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-33-43.png?updatedAt=1746615841892",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-19.png?updatedAt=1746615806634",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/Screenshot%20from%202025-05-07%2016-31-05.png?updatedAt=1746615806436",
  ];



  const aismimages = [
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-44-13.png?updatedAt=1746616839457",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-44-37.png?updatedAt=1746616839504",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-46-37.png?updatedAt=1746616843113",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-45-05.png?updatedAt=1746616838841",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-46-02.png?updatedAt=1746616839339",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-45-53.png?updatedAt=1746616839447",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-44-41.png?updatedAt=1746616839345",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-46-17.png?updatedAt=1746616839342",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-45-47.png?updatedAt=1746616839496",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-48-36.png?updatedAt=1746616843466 ",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-47-09.png?updatedAt=1746616843157",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-48-27.png?updatedAt=1746616843140",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-48-14.png?updatedAt=1746616843092",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-48-19.png?updatedAt=1746616843065",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-46-37.png?updatedAt=1746616843113",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-45-21.png?updatedAt=1746616839507",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-44-37.png?updatedAt=1746616839504",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-45-40.png?updatedAt=1746616839452",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-48-27.png?updatedAt=1746616843140",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-48-19.png?updatedAt=1746616843065",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-48-14.png?updatedAt=1746616843092",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-45-05.png?updatedAt=1746616838841",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-45-53.png?updatedAt=1746616839447",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-46-17.png?updatedAt=1746616839342",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-46-37.png?updatedAt=1746616843113",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-45-21.png?updatedAt=1746616839507",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-44-13.png?updatedAt=1746616839457",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-47-09.png?updatedAt=1746616843157",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-48-27.png?updatedAt=1746616843140",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-48-19.png?updatedAt=1746616843065",
    "https://ik.imagekit.io/ifixtechglobal/New-GYAANi/GYAANi/aism/Screenshot%20from%202025-05-07%2016-45-40.png?updatedAt=1746616839452",

  ]



  const partnerImagesMap = {
    GYAANi: GYANNiimages,
    aism: aismimages,
    // inspire: [...],
    // "auto-bot": [...],
    // insight: [...]
  };
  
  return (
    <>
      <Box m="20px">
        <Box
          className="text-center"
          justifyContent="space-between"
          alignItems="center"
        >
          <Header
            title={
              <>
                Welcome to <span className="gyaani-gradient">GYAANi</span>
              </>
            }
            // subtitle="GenAI Powered Data-Driven Automation"
            subtitle="Crafted in India, Designed for the World."
          />

          <ToastContainer />
        </Box>

        {/* GRID & CHARTS */}
        <div className="mx-auto w-fit">
          <div className="p-6 font-sans relative">
            <div className="space-y-6">
              {partners.map((partner) => (
                <div key={partner.id} className="flex items-center">
                  <div className="flex items-center w-64">
                    <input
                      type="radio"
                      id={`partner-${partner.id}`}
                      name="partner"
                      className="h-5 w-5 cursor-pointer"
                      onChange={() => handlePartnerSelect(partner.id)}
                      checked={selectedPartner === partner.id}
                    />
                    <label
                      htmlFor={`partner-${partner.id}`}
                      className="ml-4 cursor-pointer"
                    >
                      <span className="px-6 py-1 inline-block w-48 text-center">
                        <span
                          style={{ color: partner.color }}
                          className="text-xl font-medium"
                        >
                          {partner.name}
                        </span>
                      </span>
                    </label>
                  </div>

                  <div className="flex items-center">
                    {creditOptions.map((credit, index) => (
                      <div
                        key={`${partner.id}-${credit}`}
                        className="flex items-center"
                        style={{ width: "180px" }}
                      >
                        <input
                          type="radio"
                          id={`${partner.id}-${credit}`}
                          name="credit"
                          className="h-6 w-6 cursor-pointer border-2 rounded-full"
                          style={{
                            outlineColor:
                              partner.color !== "black"
                                ? partner.color
                                : undefined,
                            color:
                              partner.color !== "black"
                                ? partner.color
                                : undefined,
                          }}
                          onChange={() => handleCreditSelect(credit)}
                          checked={
                            selectedPartner === partner.id &&
                            selectedCredit === credit
                          }
                          disabled={selectedPartner !== partner.id}
                        />
                        <label
                          htmlFor={`${partner.id}-${credit}`}
                          className="ml-2 cursor-pointer text-2xl"
                          style={{
                            color:
                              index === 0
                                ? "black"
                                : index === 1
                                ? "red"
                                : index === 2
                                ? "blue"
                                : "purple",
                          }}
                        >
                          {credit}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Box>
      <Box>
        <div className="mx-auto my-10 max-w-7xl rounded-3xl bg-gray-950/5 p-2 ring-1 ring-neutral-700/10 dark:bg-neutral-800">
        <ThreeDMarquee images={partnerImagesMap[selectedPartner] || []} />
        </div>
      </Box>
    </>
  );
};

export default Partnersdashboard;
